import axios from 'axios';

export interface ClickCollect {
  pharmacyId: string;
  pharmacyName: string;
  latestOrder: string;
  avgCollectingTime: string;
  numberOfOrders: number;
  promisedDeliveryPercentage: string;
}

export const getClickCollectData = async (pharmacyId: string): Promise<ClickCollect> => {
  const url = process.env.REACT_APP_CSS_URL;
  try {
    const response = await axios.get(`${url}/pharmacy/click-collect/${pharmacyId}`, {
      params: {
        size: 20,
      },
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access_token')}`,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  } catch (_error) {
    throw Error('no data, or something');
  }
};

export interface HighscoreProps {
  avgDeliveryTime: string;
  numberOfPharmacies: number;
  pharmacies: Partial<ClickCollect[]>;
  promisedDeliveryPercentage: string;
}

export const getHighscore = async (size = 300): Promise<HighscoreProps> => {
  const url = process.env.REACT_APP_CSS_URL;
  try {
    const response = await axios.get(`${url}/pharmacy/click-collect/top`, {
      params: {
        size,
      },
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('access_token')}`,
      },
    });
    return response.data;
  } catch (_error) {
    throw Error('no data, or something');
  }
};
